module.exports = __webpack_public_path__ + "img/globe.55d9a4ca.svg";